import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useErrorMessage } from './hooks/useErrorMessage';

export const ErrorMessage: React.FC = () => {
	const {
		actions: { reload },
	} = useErrorMessage();

	return (
		<div className="rounded-small border-stroke-weaker mt-4 flex flex-col items-center justify-center border border-solid px-4 pt-10 pb-20">
			<Text as="h3" variant="heading" size="small" className="mt-8">
				<Translate value="corgi.search.error.connection.title" />
			</Text>
			<Text as="p" variant="body" className="text-typography-weak mt-5 text-center wrap-break-word">
				<Translate value="corgi.search.error.connection.subtitle" />
			</Text>
			<Button variant="secondary" size="small" className="mt-5" onClick={reload}>
				<Translate value="corgi.search.error.connection.button_text" />
			</Button>
		</div>
	);
};
